import { useEffect, useState } from "react";
import { apiGet } from "lib/apiClient";

export default function useMarketCounts(statuses, enabled, reloadKey = 0) {
  const [counts, setCounts] = useState({});
  const key = statuses.join(",");

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    Promise.all(
      key.split(",").map((status) =>
        apiGet(`/portal/markets?status=${status}&page=1&pageSize=1`)
          .then((res) => [status, res.total || 0])
          .catch(() => [status, null]),
      ),
    ).then((pairs) => {
      if (!cancelled) setCounts(Object.fromEntries(pairs));
    });
    return () => {
      cancelled = true;
    };
  }, [key, enabled, reloadKey]);

  return counts;
}
